<template>
  <div>
    <!-- 基础信息 -->
    <base-info ref="baseInfo" v-loading="loading" />
    <div class="box">
      <!-- 增信附件 -->
      <CreditExtensionAttachment
        ref="creditExtensionAttachment"
        v-loading="loading"
      />
      <!-- 申请附件 -->
      <ApplyAttachment ref="applyAttachment" v-loading="loading" />
      <!-- 审批历史 -->
      <HistoricalApproval v-if="pageType === 'edit'" ref="historicalApproval" />
    </div>
    <div class="reminder-content">
      请检查申请额度、预计交易规模、注册资本的金额单位，复核申请信息无误后再提交。
    </div>
    <div class="rj-page-card" style="text-align: center">
      <div class="rj-page-card__content">
        <el-button class="btn-style" :loading="loading" @click="submitDraft">
          保存草稿
        </el-button>
        <el-button
          type="primary"
          class="btn-style"
          :loading="loading"
          @click="submit(0)"
        >
          提交
        </el-button>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from './components/baseInfo.vue';
import CreditExtensionAttachment from './components/creditExtensionAttachment.vue';
import ApplyAttachment from './components/applyAttachment.vue';
import HistoricalApproval from './components/historicalApproval.vue';
import { numberGeneration, getCreditControl, saveCreditControlInfoApplicant, saveCreditControlInfoApplicantDraft } from '@/API/creditAxios.js';

// import eventBus from '../../../../libs/eventBus';
export default {
  data () {
    return {
      pageType: 'create',
      loading: false
    };
  },
  components: {
    baseInfo,
    CreditExtensionAttachment,
    ApplyAttachment,
    HistoricalApproval
  },
  computed: {},
  methods: {
    async submit (val) {
      try {
        const falg = this.inspect(false);
        if (falg === null) {
          return;
        }
        this.loading = true;
        const { data } = await saveCreditControlInfoApplicant(falg);
        this.loading = false;
        if (data.status === '200') {
          this.$message.success('提交成功');
          this.$router.push({
            name: 'creditControlApplicationList'
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async submitDraft () {
      const params = {
        creditControlInfo: { ...this.$refs.baseInfo.formData },
        creditControlDetail: {
          ...this.$refs.baseInfo.formDataExt
        },
        enhancementAttachmentList: this.$refs.creditExtensionAttachment.tableData,
        applicantAttachmentList: this.$refs.applyAttachment.tableData
      };
      params.creditControlDetail.customerCode = params.creditControlDetail.customerCode.join(',');
      params.creditControlDetail.payType = params.creditControlDetail.payType.join(',');
      try {
        this.loading = true;
        const { data } = await saveCreditControlInfoApplicantDraft(params);
        this.loading = false;
        if (data.status === '200') {
          this.$message.success('提交成功');
          this.$router.push({
            name: 'creditControlApplicationList'
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 检验提示
    inspect (value) {
      const params = {
        creditControlInfo: { ...this.$refs.baseInfo.formData },
        creditControlDetail: {
          ...this.$refs.baseInfo.formDataExt
        },
        enhancementAttachmentList: this.$refs.creditExtensionAttachment.tableData,
        applicantAttachmentList: this.$refs.applyAttachment.tableData
      };
      // if (value) {
      //   params.creditControlDetail.payType = params.creditControlDetail.payType.join(',');
      //   return params;
      // }
      if (!params.creditControlDetail.customerName) {
        this.$message.warning('请输入客户名称');
        return null;
      }
      if (params.creditControlDetail.customerCode.length === 0) {
        this.$message.warning('请选择客户编码');
        return null;
      }
      if (!params.creditControlDetail.proDealSize) {
        this.$message.warning('请输入预计交易规模');
        return null;
      }
      if (!params.creditControlDetail.registeredCapital) {
        this.$message.warning('请输入注册资本');
        return null;
      }
      if (!params.creditControlDetail.registeredCapitalCurrency) {
        this.$message.warning('请输入注册资本币种');
        return null;
      }
      if (!params.creditControlDetail.realRegisteredCapitalCurrency) {
        this.$message.warning('请输入实收注册资本币种');
        return null;
      }
      if (!params.creditControlDetail.legalPerson) {
        this.$message.warning('请输入法人');
        return null;
      }
      if (!params.creditControlDetail.establishTime) {
        this.$message.warning('请输入成立日期');
        return null;
      }
      if (!params.creditControlDetail.creditCode) {
        this.$message.warning('请输入统一社会信用代码');
        return null;
      }
      if (!params.creditControlDetail.address) {
        this.$message.warning('请输入注册地址');
        return null;
      }
      if (params.creditControlInfo.applicantType !== 0 && !params.creditControlInfo.applicantType) {
        this.$message.warning('请选择申请类型');
        return null;
      }
      if (!params.creditControlDetail.applicantCategory) {
        this.$message.warning('请选择申请类别');
        return null;
      }
      if (!params.creditControlDetail.applicantLimit) {
        this.$message.warning('请输入申请额度');
        return null;
      }
      if (!params.creditControlDetail.applicantPeriod) {
        this.$message.warning('请输入申请账期');
        return null;
      }
      if (params.creditControlDetail.payType.length === 0) {
        this.$message.warning('请选择付款方式');
        return null;
      }
      if (params.creditControlDetail.payType.includes('其他') && !params.creditControlDetail.otherPayType) {
        this.$message.warning('请输入具体付款方式');
        return null;
      }
      if (!params.creditControlDetail.addMeasure) {
        this.$message.warning('请输入增信措施');
        return null;
      }
      if (!params.enhancementAttachmentList || params.enhancementAttachmentList.length === 0) {
        this.$message.warning('请上传增信措施附件');
        return null;
      }
      if (!params.creditControlDetail.applicantReason) {
        this.$message.warning('请输入申请理由');
        return null;
      }
      if (!params.applicantAttachmentList || params.applicantAttachmentList.length === 0) {
        this.$message.warning('请上传申请资料');
        return null;
      }
      if (params.creditControlDetail.informFlag === 1 && !params.creditControlDetail.email && params.creditControlDetail.email === '') {
        this.$message.warning('请输入审批结果要通知的邮箱');
        return null;
      }
      if (params.creditControlDetail.email && params.creditControlDetail.email !== '') {
        if (!this.validateEmail(params.creditControlDetail.email)) {
          this.$message.warning('请输入正确的邮箱地址');
          return null;
        }
      }
      if (!params.creditControlInfo.businessName) {
        this.$message.warning('请选择锐捷商务');
        return null;
      }
      params.creditControlDetail.customerCode = params.creditControlDetail.customerCode.join(',');
      params.creditControlDetail.payType = params.creditControlDetail.payType.join(',');
      return params;
    },
    validateEmail (email) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(email);
    },
    async createNewDocument () {
      try {
        let params = {
          internal: true // true：国内，false：国际
        };
        this.loading = true;
        const result = await numberGeneration(params);
        this.loading = false;
        if (result.data.status === '200') {
          this.$refs.baseInfo.createGetData(result.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async backBtn () {
      this.$router.push({
        name: 'creditControlApplicationList'
      });
    },
    async initialization () {
      try {
        let params = {
          isControl: false,
          isEdit: true,
          orderId: this.$route.query.orderId,
          isChannelManager: false
        };
        this.loading = true;
        const result = await getCreditControl(params);
        this.loading = false;
        if (result.data.status === '200') {
          this.$refs.baseInfo.setData(result.data.data.creditControlInfo, result.data.data.creditControlDetail);
          this.$refs.creditExtensionAttachment.setData(result.data.data.enhancementAttachmentList || []);
          this.$refs.applyAttachment.setData(result.data.data.applicantAttachmentList || []);
          this.$refs.historicalApproval.setData(result.data.data.approvalHistoryVOS || []);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted () {
    this.pageType = this.$route.query.type;
    if (this.$route.query.type === 'edit') {
      this.initialization();
    } else if (this.$route.query.type === 'create') {
      this.createNewDocument();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-style {
  width: 120px;
  height: 42px;
  font-size: 16px;
}
.box {
  background-color: #fff;
  padding: 10px;
}
.reminder-content {
  padding: 10px;
  color: #f53d46;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
